import React from 'react';
import { Button } from 'primereact/button';
import { PrimeIcons } from 'primereact/api';

const STYLE: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '1rem',
  padding: '3rem 1rem',
  textAlign: 'center',
};

/** Shown in place of a page that crashed while rendering. The menu around it keeps working. */
export const PageErrorFallback = () => (
  <div style={STYLE} role='alert'>
    <h2>Esta página ha fallado</h2>
    <p>Ha ocurrido un error inesperado. Recarga la página o ve a otra sección desde el menú.</p>
    <Button label='Recargar' icon={PrimeIcons.REFRESH} onClick={() => window.location.reload()} />
  </div>
);
